import { render, staticRenderFns } from "./updatePassword2.vue?vue&type=template&id=0a15cd46&scoped=true"
import script from "./updatePassword2.vue?vue&type=script&lang=js"
export * from "./updatePassword2.vue?vue&type=script&lang=js"
import style0 from "./updatePassword2.vue?vue&type=style&index=0&id=0a15cd46&prod&lang=scss"
import style1 from "./updatePassword2.vue?vue&type=style&index=1&id=0a15cd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a15cd46",
  null
  
)

export default component.exports